// Chấm điểm phiếu THPT 3 phần theo file đáp án Excel (mẫu "Dap_an_excel_app_QM_2025.xlsx"):
//   hàng 1: "Đề\câu", 1..40 (Phần I), 1a..8d (Phần II, D/S hoặc Đ/S), 1..8 (Phần III); mỗi hàng sau = 1 mã đề.
// Thang điểm Bộ GD&ĐT 2025: Phần I 0,25/câu; Phần II mỗi câu đúng 1/2/3/4 ý = 0,1/0,25/0,5/1;
// Phần III 0,5/câu. Câu để trống trong đáp án = đề không có câu đó.
// Hàm thuần (không React) để dùng cả ở trang Quiz3ScanBatch lẫn khi kiểm thử bằng node.

const P2_POINTS = [0, 0.1, 0.25, 0.5, 1];

const cellStr = (v) => (v == null ? "" : String(v).trim());
const tf = (v) => {
  const s = cellStr(v).toUpperCase();
  if (s === "D" || s === "Đ" || s === "T" || s === "TRUE" || s === "1") return true;
  if (s === "S" || s === "F" || s === "FALSE" || s === "0") return false;
  return null;
};

// Chuẩn hoá đáp số Phần III -> số (hoặc chuỗi nếu không phải số): "0,23" "0.23" ",23" -> 0.23
export function normP3(v) {
  let s = cellStr(v).replace(/\s+/g, "").replace(/\./g, ",");
  if (!s) return null;
  if (/[?_*]/.test(s)) return { bad: s };
  const t = s.replace(",", ".");
  if (/^-?\d*\.?\d+$/.test(t) || /^-?\d+\.?$/.test(t)) return Number(t);
  return s;
}
const sameP3 = (a, b) => {
  const x = normP3(a), y = normP3(b);
  if (x == null || y == null || (x && x.bad) || (y && y.bad)) return false;
  if (typeof x === "number" && typeof y === "number") return Math.abs(x - y) < 1e-9;
  return String(x) === String(y);
};

// rows: mảng các hàng (XLSX.utils.sheet_to_json(ws, { header: 1, raw: false })) -> { [maDe]: key }
export function parseAnswerKey(rows) {
  const hi = rows.findIndex((r) => (r || []).some((c) => /^1a$/i.test(cellStr(c))));
  if (hi < 0) throw new Error("File đáp án không đúng mẫu: không thấy cột '1a' (Phần II).");
  const head = rows[hi].map(cellStr);
  const cols = { p1: [], p2: [], p3: [] };
  let zone = "p1";
  head.forEach((h, i) => {
    if (i === 0) return;
    const m2 = h.match(/^(\d+)([a-d])$/i);
    if (m2) { zone = "p3"; cols.p2.push({ i, q: Number(m2[1]) - 1, k: m2[2].toLowerCase() }); return; }
    if (/^\d+$/.test(h)) cols[zone === "p1" ? "p1" : "p3"].push({ i, q: Number(h) - 1 });
  });
  const keys = {};
  rows.slice(hi + 1).forEach((r) => {
    const ma = cellStr((r || [])[0]);
    if (!/^\d+$/.test(ma)) return;
    const p1 = [], p2 = [], p3 = [];
    cols.p1.forEach(({ i, q }) => { const v = cellStr(r[i]).toUpperCase(); p1[q] = /^[ABCD]$/.test(v) ? v : null; });
    cols.p2.forEach(({ i, q, k }) => { p2[q] = p2[q] || {}; p2[q][k] = tf(r[i]); });
    cols.p3.forEach(({ i, q }) => { const v = cellStr(r[i]); p3[q] = v || null; });
    keys[ma] = { p1, p2, p3 };
  });
  if (!Object.keys(keys).length) throw new Error("File đáp án không có mã đề nào.");
  return keys;
}

// sheet: kết quả đọc phiếu (sbd, maDe, part1[40], part2[8 {a..d}], part3[6]) -> điểm
export function gradeSheet(sheet, keys) {
  const key = keys[sheet.maDe];
  if (!key) return { ok: false, reason: `Không có đáp án mã đề ${sheet.maDe || "?"}` };
  let p1 = 0, p1n = 0, p2 = 0, p3 = 0, p3n = 0;
  const p2Detail = [];
  const wrong = [];
  key.p1.forEach((k, q) => {
    if (!k) return;
    p1n += 1;
    if ((sheet.part1 || [])[q] === k) p1 += 1; else wrong.push(`I.${q + 1}`);
  });
  key.p2.forEach((k, q) => {
    if (!k || !["a", "b", "c", "d"].some((x) => k[x] != null)) return;
    const s = (sheet.part2 || [])[q] || {};
    let c = 0;
    ["a", "b", "c", "d"].forEach((x) => { if (k[x] != null && s[x] === k[x]) c += 1; });
    p2Detail.push(c);
    p2 += P2_POINTS[c] || 0;
    if (c < 4) wrong.push(`II.${q + 1}(${c}/4)`);
  });
  key.p3.forEach((k, q) => {
    if (!k) return;
    p3n += 1;
    if (sameP3((sheet.part3 || [])[q], k)) p3 += 1; else wrong.push(`III.${q + 1}`);
  });
  const d1 = p1 * 0.25, d3 = p3 * 0.5;
  const total = Math.round((d1 + p2 + d3) * 100) / 100;
  return {
    ok: true,
    p1Correct: p1, p1Count: p1n, diem1: Math.round(d1 * 100) / 100,
    p2Detail, diem2: Math.round(p2 * 100) / 100,
    p3Correct: p3, p3Count: p3n, diem3: Math.round(d3 * 100) / 100,
    total, wrong,
  };
}
